/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  OrganizationRemoteSessionClient,
  OrganizationRemoteSessionClient$inboundSchema,
} from "./organizationremotesessionclient.js";

/**
 * Result type for the organization-administrator client listing for a single issuer.
 */
export type ListOrganizationRemoteSessionClientsResult = {
  items: Array<OrganizationRemoteSessionClient>;
  /**
   * Cursor for the next page; empty when exhausted.
   */
  nextCursor?: string | undefined;
};

/** @internal */
export const ListOrganizationRemoteSessionClientsResult$inboundSchema:
  z.ZodMiniType<ListOrganizationRemoteSessionClientsResult, unknown> = z.pipe(
    z.object({
      items: z.array(OrganizationRemoteSessionClient$inboundSchema),
      next_cursor: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        "next_cursor": "nextCursor",
      });
    }),
  );

export function listOrganizationRemoteSessionClientsResultFromJSON(
  jsonString: string,
): SafeParseResult<
  ListOrganizationRemoteSessionClientsResult,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ListOrganizationRemoteSessionClientsResult$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'ListOrganizationRemoteSessionClientsResult' from JSON`,
  );
}
